import React from 'react';
import styled from 'styled-components';
import {
  Form, Select, TimePicker, Input, Button, Radio,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import MaskedInput from 'antd-mask-input';

export const StyledForm = styled(Form)`
  width: 100%;
  .ant-form-item-label > label {
    font-weight: 500;
    color: ${({ theme }) => theme.color.grey2};
    height: 22px;
  }
`;

export const FullWidthTimePicker = styled(TimePicker)`
  width: 100%;
`;

export const FullWidthSelect = styled(Select)`
  width: 100%;
`;

export const FullWidthTextarea = styled(TextArea)`
  width: 100%;
`;

export const CloseConfirmContent = () => (
  <>
  </>
);

export const FormItem = styled(Form.Item)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: flex-start;
  color: #333333;
    .ant-form-vertical .ant-form-item-label, .ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label {
      padding: 0 0 8px;
      line-height: 1.5715;
      white-space: initial;
      text-align: left;
      margin-bottom: ${(props) => props.marginBottom};
  }
`;

export const ConfirmButtonCustom = styled(Button)`
  .ant-btn-lg {
    font-size: 15px;
  }
`;

export const SelectInput = styled(Select)`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 16px;

  /* Neutral/1 */
  background: #FFFFFF;

  /* Neutral/5 */
  border: 1px solid #D9D9D9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const SelectOption = styled(Select.Option)`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 16px;

  /* Neutral/1 */
  background: #FFFFFF;

  /* Neutral/5 */
  border: 1px solid #D9D9D9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const FormInput = styled(Input)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-size: 14px;
  /* Neutral/1 */
  background: #ffffff;

  /* Neutral/5 */
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const FlexBox = styled.div`
  marginTop: 10%;
  padding: 5%;
  border: 1px solid palevioletred;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > div {
    margin: 2%;
  }
`;

export const FormInputMask = styled(MaskedInput)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 8px 12px;
  /* Neutral/1 */
  background: #ffffff;

  /* Neutral/5 */
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const FormInputPassword = styled(Input.Password)`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const InviteHr = styled.hr`
  background: #E0E0E0;
  opacity: 0.1;
`;

export const InviteHeader = styled.p`
  /* Subheading 16/regular */
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;

  /* or 171% */
  text-align: center;

  /* Gray 1 */
  color: #333333;
`;

export const RegistrationHeader = styled.p`
  /* Subheading 16/regular */
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  /* or 171% */
  text-align: center;

  /* Gray 1 */
  color: #333333;
`;

export const InviteDescription = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19.6px;

  color: #333333;
  opacity: 0.5;

  align-items: center;
  text-align: center;
`;

export const ErrorDescription = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;

  /* or 20px */

  /* Gray 1 */
  color: #333333;

  opacity: 0.5;
`;

export const CompanyDetail = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  /* Gray 3 */
  color: #828282;
`;

export const ConfirmButton = styled(Button)`
  /* Gray 4 */
  background: #bdbdbd;

  /* drop-shadow/button-primary */
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
  border-radius: 2px;
`;

export const BackButton = styled(Button)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  /* identical to box height, or 150% */
  text-align: center;
  text-decoration-line: underline;

  /* Gray 1 */
  color: #333333;

  opacity: 0.5;
`;

export const CheckButton = styled(Button)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  display: 'inline-block';
  display: block;

  /* Gray 4 */
  color: #BDBDBD;
  borderColor: #FFFFFF;
  background: #FFFFFF;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

export const InlineFlex = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const FieldDescription = styled.a`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  pointer-events: none;
  color: #333333;
  opacity: 0.5;
`;

export const Consent = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  color: #333333;
  opacity: 0.8;
`;

export const ConfidentialityClausule = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  opacity: 0.8;

  /* Gray 3 */
  color: #828282;
`;

export const WelcomeLabel = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 35px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #333333;
`;

export const CompanyDetailsHeader = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;

  /* or 25px */
  display: flex;
  align-items: center;
  text-align: center;

  color: #333333;
`;

export const CompanyDetailsHeaderDescription = styled.p`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;

  /* or 25px */
  display: flex;
  align-items: center;
  text-align: center;

  color: #808080;
`;

export const FormItemLabel = styled.a`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  pointer-events: none;

  /* Gray 1 */
  color: #333333;
`;

export const FormItemLabelDescription = styled.a`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  pointer-events: none;

  /* identical to box height, or 17px */

  /* Gray 1 */
  color: #333333;

  opacity: 0.5;
`;

export const ItemLabel = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  /* identical to box height */

  /* Gray 1 */
  color: #333333;
`;

export const RadioButton = styled(Radio.Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 74px;

  width: 540px;
  height: 100%;

  margin-bottom: 10px;
  border: 1px solid #d9d9d9;
  box-shadow: 0px 1px 5px rgba(51, 51, 51, 0.04);
  border-radius: 2px;

  text-align: center;
`;

export const RadioButtonRegion = styled(Radio.Button)`
  padding: 8px 12px;

  width: 120px;
  height: 50px;

  border: 1px solid #d9d9d9;
  box-shadow: 0px 1px 5px rgba(51, 51, 51, 0.04);
  border-radius: 1px;

  text-align: center;
`;

export const RadioButtonText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  /* or 183% */
  display: table-cell;
  vertical-align: middle;

  /* Gray 1 */
  color: #333333;
`;

export const RadioButtonRegionText = styled.p`

font-family: 'Roboto';
font-style: normal;
font-weight: 300;
font-size: 16px;

/* Gray 1 */
color: #333333;

margin: 0px;
`;
